<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <!-- <b-card-header>
                        <span class="h5">ANEXOS</span>
                    </b-card-header> -->
                    <b-card-body>
                        <h5 class="heading-1 mb-4">
                            <span>ANEXOS</span>
                            <div class="float-right">
                                <span class="text-primary">
                                    <i
                                        class="fa fa-refresh fa-lg icon-button"
                                        title="Atualizar"
                                        @click.stop="obterAnexos()"
                                    ></i>
                                </span>
                            </div>
                        </h5>
                        <app-tabela
                            :itens="anexos"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                        >
                            <template slot="botoes">
                                <b-button-group class="float-right">
                                    <b-button
                                        variant="success"
                                        @click.stop="inserirAnexo()"
                                        v-if="mostrarBtnInserirAnexo"
                                        >Inserir Anexo</b-button
                                    >
                                    <b-button
                                        variant="warning"
                                        @click.stop="$emit('fechar')"
                                        ><i class="fa fa-times-circle"></i>
                                        Fechar Anexos</b-button
                                    >
                                </b-button-group>
                                <slot name="botoes"></slot>
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <contratacao-anexo-download
                                    :anexo="data"
                                    :servicos="obterServicos()"
                                ></contratacao-anexo-download>
                                <contratacao-anexo-excluir
                                    :anexo="data"
                                    :servicos="obterServicos()"
                                    @obterAnexosAtualizados="obterAnexos()"
                                ></contratacao-anexo-excluir>
                                <slot name="acoes" v-bind="data"></slot>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        <contratacao-anexo-form
            ref="contratacaoAnexoForm"
            @obterAnexosAtualizados="obterAnexos()"
            :contratacao="contratacao"
            :servicos="obterServicos()"
        ></contratacao-anexo-form>
    </div>
</template>

<script>
import ContratacaoAnexoDownload from './ContratacaoAnexoDownload'
import ContratacaoAnexoForm from './ContratacaoAnexoForm'
import ContratacaoAnexoExcluir from './ContratacaoAnexosExcluir'
import ContratacoesAnexosServicos from './ContratoesAnexosServicos'

export default {
    props: {
        contratacao: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            anexos: [],
            campos: [
                {
                    key: 'tipoDescr',
                    label: 'Tipo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descritivo',
                    label: 'Descritivo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nomeArquivoOriginal',
                    label: 'Arquivo'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 0
        }
    },

    methods: {
        obterServicos() {
            return ContratacoesAnexosServicos
        },

        obterAnexos() {
            this.$store.dispatch('addRequest')
            ContratacoesAnexosServicos.obterAnexos(
                this.contratacao.codContratacao
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.anexos = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        inserirAnexo() {
            this.$refs.contratacaoAnexoForm.mostrarModal = true
        }
    },

    created() {
        this.obterAnexos()
    },

    computed: {
        mostrarBtnInserirAnexo() {
            return this.$temAcesso('CRED-CONT-ANX-02')
        }
    },

    components: {
        ContratacaoAnexoForm,
        ContratacaoAnexoDownload,
        ContratacaoAnexoExcluir
    }
}
</script>
